"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ArrowDown = function ArrowDown(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 24 24",
    height: "24",
    width: "24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.249,7.207l10.984,12.471l0,0c0.407,0.425,1.082,0.439,1.507,0.032c0.011-0.01,0.021-0.021,0.032-0.032L23.751,7.207 c0.362-0.408,0.325-1.032-0.083-1.393C23.66,5.807,23.652,5.8,23.644,5.793l-1.85-1.557c-0.429-0.362-1.069-0.312-1.438,0.111 L12.191,13.8c-0.09,0.105-0.248,0.116-0.353,0.026c-0.009-0.008-0.018-0.017-0.026-0.026L3.644,4.346 C3.467,4.143,3.217,4.019,2.948,4C2.679,3.976,2.412,4.062,2.207,4.238L0.356,5.793C0.149,5.964,0.021,6.211,0,6.478 C-0.02,6.745,0.07,7.008,0.249,7.207z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
ArrowDown.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
ArrowDown.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = ArrowDown;